import { render, staticRenderFns } from "./SmsTemplateForm.vue?vue&type=template&id=f41fdd52&scoped=true"
import script from "./SmsTemplateForm.vue?vue&type=script&lang=ts"
export * from "./SmsTemplateForm.vue?vue&type=script&lang=ts"
import style0 from "./SmsTemplateForm.vue?vue&type=style&index=0&id=f41fdd52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41fdd52",
  null
  
)

export default component.exports